import {
  rowHasMappedKey,
  trimUpdateValue,
  checkDuplicateKeyInBulkUpdate,
  getIdByExactName,
  parseCurrency,
} from './sharedImportHelpers';

const UPDATE_KEYS = [
  'hourlyBillingRate',
  'dailyBillingRate',
  'weeklyBillingRate',
  'monthlyBillingRate',
];

export const buildUpdateEquipmentImportPayload = (row, context) => {
  const name = trimUpdateValue(row.name);
  const code = rowHasMappedKey(row, 'code') ? trimUpdateValue(row.code) : null;

  let equipmentId;
  if (code) {
    const equipment = context.equipmentCodeMap?.[code];
    if (!equipment) {
      throw new Error(`No equipment found with ID "${code}"`);
    }
    checkDuplicateKeyInBulkUpdate({
      key: code,
      label: 'ID',
      seen: context.bulkEquipmentUpdateSeenCodes,
    });
    equipmentId = equipment.id;
  } else if (name) {
    equipmentId = getIdByExactName({
      name,
      map: context.equipmentMap,
      errorMessage: `Equipment "${name}" not found`,
    });
    checkDuplicateKeyInBulkUpdate({
      key: name,
      label: 'Name',
      seen: context.bulkEquipmentUpdateSeenNames,
    });
  } else {
    throw new Error('Name or ID is required');
  }

  const payload = {};

  UPDATE_KEYS.forEach((key) => {
    if (rowHasMappedKey(row, key)) {
      payload[key] = parseCurrency(row[key]);
    }
  });

  if (Object.keys(payload).length === 0) {
    throw new Error('No updatable fields in mapped columns');
  }

  payload.customData = [];

  return { updateId: equipmentId, payload };
};